import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Switch, Route } from 'react-router-dom'

import {
  HOME,
  QUOTE,
  RATES_FORM,
  POLICY_FORM,
  HIRE,
  CERTS
} from 'Global/paths'

import { getProducts, getProviders } from 'Redux/Global/actions'

import { useSaga } from 'Redux/Global'


import Start from 'Containers/Home'
import Quote from 'Containers/Quote'
import RatesForm from 'Containers/RatesForm'
import PolicyForm from 'Containers/PolicyForm'
import Hire from 'Containers/Hire'
import Certs from 'Containers/Certs'



import Page from './style'

const App = () => {
  useSaga()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getProducts())
    dispatch(getProviders())
    
  }, [dispatch])


  return (
      <Page>
        <Switch>
          <Route path={QUOTE} component={Quote} />
          <Route path={RATES_FORM} component={RatesForm} />
          <Route path={POLICY_FORM} component={PolicyForm} />
          <Route path={HIRE} component={Hire} />
          <Route path={CERTS} component={Certs} />
          <Route component={RatesForm} />
        </Switch>
      </Page>
  )
}

export default App
